export default __webpack_public_path__ + "media/images/logo-jet-story-new-f1b17b4e573b0cb172bb681981630c94.png";